// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"13":"e38fdff7","445":"5844e94c","518":"63b7dee4","571":"3cf947ad"}[chunkId] + ".js";
};